import {useQuery} from '@tanstack/react-query';

import {apiService} from '../apiService';
import {useAuth} from '../contexts/AuthContext';

export const userInfoQueryKey = (uid) => ['userInfo', uid];

const USER_INFO_POLL_INTERVAL_MS = 60_000;

export const useUserInfo = () => {
  const {currentUser} = useAuth();
  const uid = currentUser?.uid;

  const query = useQuery({
    queryKey: userInfoQueryKey(uid),
    queryFn: async () => {
      const data = await apiService.get(
        `/api/check-user-admin-status?uid=${uid}`,
      );
      return {
        role: data?.role ?? null,
        orgCount: data?.org_count ?? 1,
        orgId: data?.org_id ?? null,
        companyName: data?.company_name || '',
        masterOrg: data?.master_org ?? null,
        parentId: data?.parent_id ?? null,
      };
    },
    enabled: !!uid,
    refetchInterval: USER_INFO_POLL_INTERVAL_MS,
  });

  const isMultiOrg =
    query.data?.role === 'admin' || (query.data?.orgCount ?? 0) > 1;

  return {...query, isMultiOrg};
};
